<template>
  <!-- 律师解答 -->
  <div id="articleclaim">
    <!-- banner  -->
    <section class="atcbanner">
      <img src="../../assets/claim/atcbanner.png" alt="" />
    </section>

    <section><atcclswipe /></section>

    <section><atcclcont /></section>

  </div>
</template>

<script>

import atcclswipe from "./child/atcclswipe"; //解答轮播
import atcclcont from "./child/atcclcont"; //解答列表

export default {
  name: "articleclaim",
  components: {

    // 私
    atcclswipe,
    atcclcont,
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
#articleclaim {
  background-color: #fff;
  .w_10f8 {
    width: 100%;
    background-color: #f8f8f8;
  }
  .atcbanner {
    max-width: 1920px;
    width: 100%;
    height: 520px;
    overflow: hidden;
    margin: 0 auto;
    img {
      width: 1920px;
    }
  }
}
</style>
